module.exports = {
  uploadCancelledError: 'Beim Abbrechen ist ein Fehler aufgetreten',
  fileLoadError: 'Beim Laden ist ein Fehler aufgetreten',
  uploadFailed: 'Beim Hochladen ist ein Fehler aufgetreten',
  deleteFile: 'Beim Löschen ist ein Fehler aufgetreten',
  fileTypeUnsupported: 'Dieser Dateityp wird nicht unterstützt',
  browseFile: 'Datei durchsuchen',
  invalidFile: 'Ungültige Datei ausgewählt',
  uploadCancelled: 'Upload abgebrochen',
  fileInformationUnavailable: 'Dateiinformationen nicht verfügbar',
  upToMB: 'Bis zu {size}MB',
  or: 'oder',
  waitForFileInformation: 'Warte auf Dateiinformationen',
  loading: 'Lade...',
  corruptFileDetected: 'Bitte vergewissern Sie sich, dass die Datei nicht aus einem Zip-Ordner stammt und nicht beschädigt ist.',
  dragItemsHere: 'Datei hierher ziehen',
}
